import React from 'react';
import { Building2, MapPin, Briefcase, Globe } from 'lucide-react';
import { companyInfo } from '../../data/mock';

const About = () => {
  const highlights = [
    {
      icon: Building2,
      title: 'UAE Free Zone Company',
      description: 'Registered under Ras Al Khaimah Economic Zone (RAKEZ) with full operational license.',
    },
    {
      icon: Briefcase,
      title: 'Software House',
      description: 'Specialized in computer systems and communication systems design and development.',
    },
    {
      icon: MapPin,
      title: 'Strategic Location',
      description: 'Based in Al Hamra Industrial Zone, positioned for global B2B technology services.',
    },
    {
      icon: Globe,
      title: 'International Reach',
      description: 'Serving enterprise clients worldwide with scalable technology solutions.',
    },
  ];

  return (
    <section id="about" className="py-24 bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="max-w-3xl mb-16">
          <span className="text-blue-400 font-medium text-sm tracking-wider uppercase mb-4 block">
            About Us
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">
            Building the Infrastructure for
            <span className="text-blue-400"> Modern Business</span>
          </h2>
          <p className="text-slate-400 text-lg leading-relaxed">
            Botlab Solutions FZ-LLC is a technology company headquartered in the United Arab Emirates. 
            We specialize in developing high-performance software platforms, player account management systems, 
            and enterprise-grade infrastructure that powers businesses across the globe.
          </p>
        </div>

        {/* Highlights Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {highlights.map((item, index) => (
            <div
              key={index}
              className="group p-6 bg-slate-800/50 rounded-2xl border border-slate-700/50 hover:border-blue-500/30 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-12 h-12 bg-blue-500/10 rounded-xl flex items-center justify-center mb-4 group-hover:bg-blue-500/20 transition-colors">
                <item.icon className="w-6 h-6 text-blue-400" />
              </div>
              <h3 className="text-white font-semibold text-lg mb-2">{item.title}</h3>
              <p className="text-slate-400 text-sm leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>

        {/* Company Details Card */}
        <div className="bg-gradient-to-br from-slate-800/80 to-slate-800/40 rounded-3xl border border-slate-700/50 p-8 lg:p-12">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-2xl font-bold text-white mb-4">Legal Information</h3>
              <p className="text-slate-400 mb-6">
                We operate as a fully licensed Free Zone Limited Liability Company, adhering to 
                all regulatory requirements and maintaining the highest standards of corporate governance.
              </p>
              <div className="space-y-4">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-lg bg-slate-700/50 flex items-center justify-center flex-shrink-0">
                    <Building2 className="w-5 h-5 text-blue-400" />
                  </div>
                  <div>
                    <p className="text-slate-500 text-sm">Legal Entity</p>
                    <p className="text-white font-medium">{companyInfo.legalType}</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-lg bg-slate-700/50 flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-5 h-5 text-blue-400" />
                  </div>
                  <div>
                    <p className="text-slate-500 text-sm">Registered Authority</p>
                    <p className="text-white font-medium">{companyInfo.authority}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="lg:pl-12 lg:border-l border-slate-700/50">
              <div className="bg-slate-900/50 rounded-2xl p-6">
                <p className="text-slate-500 text-sm mb-2">Business Activity</p>
                <p className="text-white font-medium text-lg mb-6">{companyInfo.activity}</p>
                <p className="text-slate-500 text-sm mb-2">Registered Address</p>
                <p className="text-slate-300 text-sm leading-relaxed">{companyInfo.address}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
